import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, LEFT, RIGHT } from '../structure/cell';
import { ProductQuantity } from './product_price_and_quantity/product_quantity';
import Translation from '../../translation/translation';

export function ProductQuantityRow(props) {
    return (
        <Row className="product-qty">
            <Cell side={LEFT} colSpan={2}>
                <Translation
                    translationKey="pdp-quantity"
                    className="product-qty__label"
                />
            </Cell>

            <Cell side={RIGHT}>
                <ProductQuantity
                    availableQuantities={props.availableQuantities}
                    quantity={props.quantity}
                    onQuantityChange={props.onQuantityChange}
                />
            </Cell>
        </Row>
    );
}

ProductQuantityRow.propTypes = {
    availableQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    quantity: PropTypes.number.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
};
